// External links always open in a new tab and carry rel="noopener noreferrer": the map state stays where it is. Same rule in
// tools/build_public_pages.py for the generated documents; tests/js/external-links.test.mjs checks markup, catalogs and documents.
export const EXTERNAL_REL = 'noopener noreferrer';
// HTML string: every <a> with an http(s) href gets target/rel (existing ones are replaced).
export const externalAnchors = html => html.replace(/<a\s[^>]*>/g, tag => {
  if (!/\shref="https?:/.test(tag)) return tag;
  return tag.replace(/\s(target|rel)="[^"]*"/g, '').replace(/>$/, ` target="_blank" rel="${EXTERNAL_REL}">`);
});
